import { createFileRoute } from "@tanstack/react-router";
import EffectivePermissionsView from "@/features/settings/components/effective-permissions-view";

function EffectivePermissionsRoute() {
  const { userId } = Route.useParams();
  return <EffectivePermissionsView userId={userId} />;
}

export const Route = createFileRoute(
  "/_admin/settings/users/$userId/effective-permissions"
)({
  component: EffectivePermissionsRoute,
});
